import { render, staticRenderFns } from "./DetalleCompra.vue?vue&type=template&id=3adaa238"
import script from "./DetalleCompra.vue?vue&type=script&lang=js"
export * from "./DetalleCompra.vue?vue&type=script&lang=js"
import style0 from "./DetalleCompra.vue?vue&type=style&index=0&id=3adaa238&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports